<!--
 * @Description: 登录
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:40:58
 * @LastEditTime: 2025-12-09 14:15:32
-->
<template>
 <div div style="background:#fff">
    <div class="yygh-title">预约挂号</div>
    <Common>
      <template slot="cd">
        <CdhospitalBookTab currentIndex="0"/>
        <CdhospitalWechatBook/>
      </template>
      <template slot="sz">
        <SzhospitalBookTab currentIndex="0"/>
        <SzhospitalWechatBook />
      </template>
      <template slot="hf">
        <HfhospitalBookTab currentIndex="0"/>
        <HfhospitalWechatBook />
      </template>
    </Common>
    </div>
    
</template>

<script>
import CdhospitalWechatBook from "@/components/hospitalWechatBook/cdhospitalWechatBook"
import SzhospitalWechatBook from "@/components/hospitalWechatBook/szhospitalWechatBook"
import HfhospitalWechatBook from "@/components/hospitalWechatBook/hfhospitalWechatBook"
import CdhospitalBookTab from "@/components/hospitalBookTab/cdhospitalBookTab"
import SzhospitalBookTab from "@/components/hospitalBookTab/szhospitalBookTab"
import HfhospitalBookTab from "@/components/hospitalBookTab/hfhospitalBookTab"
export default{
  components:{
    CdhospitalWechatBook,
    SzhospitalWechatBook,
    HfhospitalWechatBook,
    SzhospitalBookTab,
    CdhospitalBookTab,
    HfhospitalBookTab
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>
.yygh-title{
  text-align: center;
  font-size: 30px;
  line-height: 30px;
  padding-top:50px;
  background: #fff;
}
.m-screen-mobile .yygh-title {
  padding-top: 0.8rem;
  font-size: 0.45rem!important;
  text-align: center;
  line-height: 0.46rem!important;
}
</style>